var _style, _path, _polygon, _path2, _polygon2, _rect, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoNas210 = function SvgLogoNas210(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DDDDDD;}\n\t.st1{fill:#0F143F;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:#222222;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:url(#SVGID_4_);}\n\t.st8{fill:url(#SVGID_5_);}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:#4289A1;}\n\t.st12{fill:#1ABC9C;}\n\t.st13{fill:url(#SVGID_8_);}\n\t.st14{fill:#0A1F4E;}\n\t.st15{fill:url(#SVGID_9_);}\n\t.st16{fill:url(#SVGID_10_);}\n\t.st17{fill:url(#SVGID_11_);}\n\t.st18{fill:url(#SVGID_12_);}\n\t.st19{fill:url(#SVGID_13_);}\n\t.st20{fill:url(#SVGID_14_);}\n\t.st21{fill:url(#SVGID_15_);}\n\t.st22{fill:url(#SVGID_16_);}\n\t.st23{fill:#170042;}\n\t.st24{fill:url(#SVGID_17_);}\n\t.st25{fill:url(#SVGID_18_);}\n\t.st26{fill:url(#SVGID_19_);}\n\t.st27{fill:url(#SVGID_20_);}\n\t.st28{fill:url(#SVGID_21_);}\n\t.st29{fill:url(#SVGID_22_);}\n\t.st30{fill:url(#SVGID_23_);}\n\t.st31{fill:url(#SVGID_24_);}\n\t.st32{fill:#373742;}\n\t.st33{fill:#00F8AF;}\n\t.st34{fill:url(#SVGID_25_);}\n\t.st35{fill:url(#SVGID_26_);}\n\t.st36{fill:url(#SVGID_27_);}\n\t.st37{fill:url(#SVGID_28_);}\n\t.st38{fill:url(#SVGID_29_);}\n\t.st39{fill:url(#SVGID_30_);}\n\t.st40{fill:url(#SVGID_31_);}\n\t.st41{fill:#0072FD;}\n\t.st42{fill:url(#SVGID_32_);}\n\t.st43{fill:url(#SVGID_33_);}\n\t.st44{fill:url(#SVGID_34_);}\n\t.st45{fill:url(#SVGID_35_);}\n\t.st46{fill:url(#SVGID_36_);}\n\t.st47{fill:url(#SVGID_37_);}\n\t.st48{fill:url(#SVGID_38_);}\n\t.st49{fill:url(#SVGID_39_);}\n\t.st50{fill:url(#SVGID_40_);}\n\t.st51{fill:url(#SVGID_41_);}\n\t.st52{fill:url(#SVGID_42_);}\n\t.st53{fill:#3D3F45;}\n\t.st54{fill:url(#SVGID_43_);}\n\t.st55{fill:url(#SVGID_44_);}\n\t.st56{fill:url(#SVGID_45_);}\n\t.st57{fill:url(#SVGID_46_);}\n\t.st58{fill:url(#SVGID_47_);}\n\t.st59{fill:url(#SVGID_48_);}\n\t.st60{fill:url(#SVGID_49_);}\n\t.st61{fill:url(#SVGID_50_);}\n\t.st62{fill:url(#SVGID_51_);}\n\t.st63{fill:url(#SVGID_52_);}\n\t.st64{fill:url(#SVGID_53_);}\n\t.st65{fill:url(#SVGID_54_);}\n\t.st66{fill:url(#SVGID_55_);}\n\t.st67{fill:url(#SVGID_56_);}\n\t.st68{fill:url(#SVGID_57_);}\n\t.st69{fill:url(#SVGID_58_);}\n\t.st70{fill:url(#SVGID_59_);}\n\t.st71{fill:url(#SVGID_60_);}\n\t.st72{fill:url(#SVGID_61_);}\n\t.st73{fill:url(#SVGID_62_);}\n\t.st74{fill:url(#SVGID_63_);}\n\t.st75{fill:#8F8F8F;}\n\t.st76{fill:url(#SVGID_64_);}\n\t.st77{fill:url(#SVGID_65_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -93.3156,
    y1: 252.023,
    x2: 569.4939,
    y2: 252.023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0072FD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.78,227.98l-29.03,48.09l15.15,0l5.12-8.66h5.01h2.57c5.9,0,10.69-4.79,10.68-10.7h-11.94l9.59-16.23 l21.21,35.59h15.34l-29.01-48.09H108.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -134.6941,
    y1: 252.0226,
    x2: 424.1584,
    y2: 252.0226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0072FD"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "59.17,259.45 24.58,227.98 11.24,227.98 11.23,276.07 24.57,276.07 24.58,244.71 59.16,276.07  72.54,276.07 72.55,227.98 59.17,227.98  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.068,
    y1: 252.0172,
    x2: 562.2064,
    y2: 252.0172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0072FD"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.41,247.52l-29.98-0.01c-2.18-0.13-3.87-1.86-3.87-4.32c0-3,2.53-4.22,3.98-4.22h24.58 c7.01,0,13.27-4.4,15.65-10.99h-42.88c-7.15,0-13.95,6.64-13.95,14.8c0,11.64,10.12,15.25,14.2,15.25h29.7 c3.18,0,3.98,2.68,3.98,3.72c0,2.28-1.69,3.91-3.63,3.91h-40.01l-3.65,10.4h45.47c10.39,0,13.97-9.32,13.97-13.58 C217.97,254.29,212.23,247.52,204.41,247.52z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.8241,
    y1: 233.1882,
    x2: 324.4403,
    y2: 241.0012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#00FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F8AF"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "457.91,228.1 458.8,276.19 472.02,275.94 471.13,227.86  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0025,
    y1: 230.9129,
    x2: 324.6188,
    y2: 238.7259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#00FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F8AF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 227.98,
    className: "st8",
    width: 13.22,
    height: 48.09
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.5354,
    y1: 249.6186,
    x2: 323.1517,
    y2: 257.4316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#00FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F8AF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M290.11,232.74c-3.18-3.16-7.57-4.76-13.13-4.76h-46.54c0,5.91,4.79,10.7,10.71,10.7h6.19v0.01l26.24-0.01 c0.14,0,0.31,0,0.45,0.02c2.18,0.07,4.01,0.62,5.42,1.87c1.49,1.25,2.26,3.01,2.26,5.25l0,12.2c0,2.17-0.78,3.91-2.31,5.22 c-1.47,1.29-3.39,1.95-5.81,1.98h-29.9l0.01-6.59l0-1l0.01-10.71l-13.27,0l0,11.7l-0.01,17.44h46.54c5.49,0,9.87-1.6,13.14-4.85 c3.24-3.2,4.86-6.89,4.86-11.04l0-16.31c0-1.89-0.31-3.66-0.94-5.31C293.23,236.43,291.93,234.5,290.11,232.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.9517,
    y1: 244.3111,
    x2: 323.568,
    y2: 252.1241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#00FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F8AF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M329.45,227.98l-29.03,48.09l15.15,0l5.12-8.66h5.01h2.57c5.9,0,10.69-4.79,10.68-10.7h-11.94l9.59-16.23 l21.21,35.59h15.34l-29.01-48.09H329.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.2987,
    y1: 239.887,
    x2: 323.9149,
    y2: 247.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#00FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F8AF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M444.14,260.18l0-16.31c0-4.31-1.61-8-4.84-11.13c-3.19-3.16-7.57-4.76-13.14-4.76H396.6 c-5.5,0-9.88,1.6-13.15,4.76c-3.23,3.16-4.84,6.9-4.84,11.24l0,16.08c0,4.23,1.61,7.93,4.88,11.16c3.34,3.24,7.69,4.84,13.11,4.84 h18.13l1.34,1.14c5.26,4.47,11.93,6.93,18.84,6.93h9.24l-11.01-9.17c2.34-0.8,4.4-2.03,6.13-3.74 C442.52,268.03,444.14,264.33,444.14,260.18z M430.87,258.01c0,2.21-0.77,3.96-2.27,5.22c-1.42,1.26-3.38,1.94-5.84,1.98h-22.75 c-2.31,0-4.23-0.65-5.8-1.98c-1.5-1.26-2.26-2.97-2.26-5.11l0-12.39c0.08-2.21,0.85-3.96,2.27-5.26c1.5-1.33,3.42-1.98,5.8-1.98 h22.75c2.42,0,4.34,0.65,5.84,1.98c1.46,1.26,2.23,3.01,2.27,5.26L430.87,258.01z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoNas210, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo_NAS 2-10.a38cd55c.svg";
export { ForwardRef as ReactComponent };